// extracted by mini-css-extract-plugin
export default {"htp":"howToPlay_htp__YIX-T","border":"howToPlay_border__rGcw1"};